import { api } from "@/lib/apiClient";

export type WebsiteTileCopy = {
  eyebrow: string;
  title: string;
  text: string;
  detail: string;
  badge: string;
};

export type WebsiteTile = {
  id: string;
  size: "normal" | "wide" | "large";
  image: string;
  href: string;
  visible: boolean;
  highlights: string[];
  de: WebsiteTileCopy;
  en: WebsiteTileCopy;
};

export type WebsiteBlocks = Partial<Record<string, WebsiteTile[]>>;

export type WebsiteContentDocument = {
  texts: { de: Record<string, string>; en: Record<string, string> };
  shared: Record<string, string>;
  images: Record<string, { src: string; alt?: Record<string, string> }>;
  blocks?: WebsiteBlocks;
};

export async function fetchWebsiteContent(): Promise<WebsiteContentDocument> {
  return api.get<WebsiteContentDocument>("/api/v1/website-content");
}

export async function saveWebsiteContent(document: WebsiteContentDocument): Promise<WebsiteContentDocument> {
  return api.put<WebsiteContentDocument>("/api/v1/website-content", document);
}

export async function uploadWebsiteImage(file: File): Promise<string> {
  const body = new FormData();
  body.append("file", file);
  const data = await api.post<{ url: string }>("/api/v1/website-content/media", undefined, {
    rawBody: body,
  });
  return data.url;
}
